/**
 * Base-path-aware fetch helper.
 *
 * When the frontend is built to serve under a URL sub-path (per-PR preview
 * environments set NEXT_PUBLIC_BASE_PATH, e.g. "/_services/ephemeral-fe/pr-123"),
 * the browser resolves a bare fetch("/api/...") against the ORIGIN, dropping the
 * sub-path and 404-ing. Next.js rewrites links/assets for basePath automatically
 * but does NOT touch fetch() calls. This helper prepends the base path so API
 * calls resolve correctly under any sub-path, and is a no-op at the root.
 */

const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

/** Join a base path and an absolute app path without doubling slashes. */
export function withBasePath(path: string, basePath: string = BASE_PATH): string {
  // Leave fully-qualified URLs alone.
  if (/^https?:\/\//.test(path)) return path;
  if (!basePath) return path;
  const trimmedBase = basePath.replace(/\/$/, "");
  const trimmedPath = path.startsWith("/") ? path : `/${path}`;
  return `${trimmedBase}${trimmedPath}`;
}

/** Drop-in replacement for fetch() that respects NEXT_PUBLIC_BASE_PATH. */
export function apiFetch(input: string, init?: RequestInit): Promise<Response> {
  return fetch(withBasePath(input), init);
}
